import { object, string } from "yup";

const ServiceFeeSchema = object().shape({
  departureCity: object()
    .nullable()
    .required("Zgjedh qytetin e nisjes!"),
  arrivalCity: object()
    .nullable()
    .required("Zgjedh qytetin e mbërritjes!")
    .test(
      "not-same-as-departure",
      "Qyteti i mbërritjes duhet të jetë i ndryshëm nga qyteti i nisjes!",
      // eslint-disable-next-line @typescript-eslint/typedef
      function (value) {
        const { departureCity }: any = this.parent;
        if (!value || !departureCity) return true;
        return value.id !== departureCity.id;
      }
    ),
  percentage: string()
    .required("Vendos përqindjen!")
    .test("valid-percentage", "Përqindja duhet të jetë numër valid!", (value) => {
      if (!value) return false;
      const num = parseFloat(value);
      return !isNaN(num) && num > 0 && num <= 100;
    })
});

export default ServiceFeeSchema;
